/*
 * Wave B-1.6. KIC mobile bottom nav cart-badge live updater.
 * Subscribes to PUB_SUB_EVENTS.cartUpdate (theme-working/assets/pubsub.js).
 * Defer-loaded; pubsub.js is also defer so window globals will be ready by
 * the time DOMContentLoaded fires. Wraps subscribe call in a polling
 * fallback so first-paint hiccups don't lose the binding.
 */
(function () {
  'use strict';

  // R10.12 (2026-05-01) — idempotent bind flag mirrors R10.5 in kic-toasts.js.
  // Polling-fallback loop can attach two subscribers to PUB_SUB_EVENTS.cartUpdate
  // when pubsub.js initialises mid-cycle. Single bind keeps cart-badge updates
  // from firing twice per /cart/add.js call.
  var _kicBNBound = false;
  function bind() {
    if (_kicBNBound) return true;
    // PUB_SUB_EVENTS is a `const` in constants.js (classic script) and does NOT
    // attach to window; subscribe() / publish() ARE function declarations and do.
    // Use bare-name `typeof PUB_SUB_EVENTS` for the const, window.subscribe for the fn.
    // Mirrors the R4.5 fix in kic-toasts.js.
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    _kicBNBound = true;
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = (event && event.cartData && event.cartData.item_count) || 0;
      var item = document.querySelector('[data-kic-bn-cart]');
      if (!item) return;
      var badge = item.querySelector('[data-kic-bn-badge]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'kic-bn__badge';
          badge.setAttribute('data-kic-bn-badge', '');
          badge.setAttribute('aria-hidden', 'true');
          var label = item.querySelector('.kic-bn__label');
          item.insertBefore(badge, label || null);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      var pieces = count === 1 ? 'piece' : 'pieces';
      item.setAttribute('aria-label', 'Cart, ' + count + ' ' + pieces);
    });
    return true;
  }

  if (!bind()) {
    var attempts = 0;
    var iv = setInterval(function () {
      attempts += 1;
      if (bind() || attempts > 20) clearInterval(iv);
    }, 150);
  }

  /*
   * F11 (2026-05-08). Cart-drawer open bridge for the bottom-nav cart anchor.
   *
   * Root cause (per reports/cart-drawer-f11-investigation-2026-05-07.md):
   * Dawn assets/cart-drawer.js binds the open listener exactly once, on
   * document.querySelector('#cart-icon-bubble'). That id lives on the header
   * cart anchor (kic-v2-header.liquid). The bottom-nav cart anchor has the
   * same /cart href but no listener, so clicks at <750 CSS px navigate to
   * /cart instead of opening the drawer.
   *
   * Fix (Option M, per the investigation): wire the bottom-nav anchor to the
   * <cart-drawer> custom element directly. Native preventDefault + drawer.open()
   * mirrors the header listener's behavior, including focus-return on close.
   *
   * Fail-soft: if <cart-drawer> is missing or its open() method is not a
   * function, console.warn once and let the anchor's default /cart navigation
   * proceed. This keeps the surface useful even when the drawer module fails
   * to upgrade (slow connections, JS error elsewhere, scripts blocked).
   *
   * Idempotent: re-running bindCartDrawerBridge() is safe. The DOM-level
   * _kicBNCartBridgeBound dataset flag prevents double-listener attachment
   * when the file is parsed twice (rare; bfcache restores, app-block reload).
   */
  var _kicBNCartBridgeWarned = false;
  function bindCartDrawerBridge() {
    var item = document.querySelector('[data-kic-bn-cart]');
    if (!item) return false;
    if (item.dataset.kicBnCartBridgeBound === '1') return true;
    item.dataset.kicBnCartBridgeBound = '1';
    item.addEventListener('click', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') {
        if (!_kicBNCartBridgeWarned) {
          _kicBNCartBridgeWarned = true;
          // length-only diagnostic; no user data, no secrets
          console.warn('[kic-bn] cart-drawer element not ready; falling back to /cart');
        }
        return;
      }
      event.preventDefault();
      drawer.open(item);
    });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartDrawerBridge, { once: true });
  } else {
    bindCartDrawerBridge();
  }
  // bfcache / pageshow restore: re-run idempotent bind so listeners survive
  // a back-forward cache restore where the original listener was discarded.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) bindCartDrawerBridge();
  });
})();
